import { FAVORITES_RECEIVE, } from '../constants';
/**
 * @typedef {Object} FavoriteList
 * @property {string|null} id - The unique identifier for the favorite list.
 * @property {string[]} articleNos - The list of article numbers.
 * @property {NmasProductItemViewModel[]} items - The list of product item view models.
 */
/**
 * @type {FavoriteList}
 */
const defaultState = {
    id: null,
    articleNos: [],
    items: []
};
export const favorites = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FAVORITES_RECEIVE:
            return { ...state, ...payload };
        default:
            return state;
    }
};
